import { create } from 'zustand';

export type Toast = {
  id: string;
  title?: string;
  description?: string;
  variant?: 'success' | 'error' | 'info';
};

interface ToastState {
  toasts: Toast[];
  push: (t: Omit<Toast, 'id'>) => string;
  remove: (id: string) => void;
}

export const useToastStore = create<ToastState>((set) => ({
  toasts: [],
  push: (t) => {
    const id = Math.random().toString(36).slice(2, 9);
    const toast = { id, ...t } as Toast;
    set((s) => ({ toasts: [...s.toasts, toast] }));
    // Auto-remove after 3.5s
    setTimeout(() => set((s) => ({ toasts: s.toasts.filter(x => x.id !== id) })), 3500);
    return id;
  },
  remove: (id) => set((s) => ({ toasts: s.toasts.filter(x => x.id !== id) })),
}));

export default useToastStore;
